'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconShareAlt = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M18.5 7h-3.25a.25.25 0 0 0-.25.25V11a3 3 0 0 1-6 0V7.248A.25.25 0 0 0 8.75 7H5.5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z' }),
    _react2.default.createElement('path', { d: 'M11 11a1 1 0 0 0 2 0V5.748a.25.25 0 0 1 .25-.25h2.25a1 1 0 0 0 .707-1.707l-3.5-3.5a1 1 0 0 0-1.414 0l-3.5 3.5A1 1 0 0 0 8.5 5.5h2.25a.25.25 0 0 1 .25.25z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M12 14a.5.5 0 0 1-.5-.5V1.707L7.854 5.353a.496.496 0 0 1-.708 0 .501.501 0 0 1 0-.707l4.5-4.5A.495.495 0 0 1 12 0a.5.5 0 0 1 .354.146l4.5 4.5a.5.5 0 0 1-.354.854.5.5 0 0 1-.354-.146L12.5 1.707V13.5a.5.5 0 0 1-.5.5z' }),
    _react2.default.createElement('path', { d: 'M5 24.001c-.827 0-1.5-.673-1.5-1.5v-13c0-.827.673-1.5 1.5-1.5h4a.5.5 0 0 1 0 1H5a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1 0-1h4c.827 0 1.5.673 1.5 1.5v13c0 .827-.673 1.5-1.5 1.5H5z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M5.25 24A2.252 2.252 0 0 1 3 21.75v-12A2.252 2.252 0 0 1 5.25 7.5h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 0-.75.75v12c0 .414.336.75.75.75h13.5a.75.75 0 0 0 .75-.75v-12a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 1 0-1.5h1.5A2.252 2.252 0 0 1 21 9.75v12A2.252 2.252 0 0 1 18.75 24H5.25z' }),
    _react2.default.createElement('path', { d: 'M12 12a.75.75 0 0 1-.75-.75V2.561L8.78 5.03c-.141.142-.33.22-.53.22s-.389-.078-.53-.22c-.142-.141-.22-.33-.22-.53s.078-.389.22-.53L11.469.221a.74.74 0 0 1 .245-.163l.025-.009a.723.723 0 0 1 .522-.001l.02.007c.097.04.179.095.25.166L16.28 3.97c.142.141.22.33.22.53s-.078.389-.22.53a.749.749 0 0 1-1.06 0l-2.47-2.47v8.689A.75.75 0 0 1 12 12z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconShareAlt.displayName = 'IconShareAlt';
exports.default = IconShareAlt;